// extracted by mini-css-extract-plugin
export default {"col":"SummarySGU_col__5Jpzw","row":"SummarySGU_row__q3O0A","phase3":"SummarySGU_phase3__yHw-X"};